// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MachineModal.module.css */
.MachineModal_openModalButton__J075P {
  background-color: #7fc5bf;
  color: black;
  border: none;
  font-size: 16px;
  cursor: pointer;
  width: 9rem;
  line-height: 2.4;
}

.MachineModal_openModalButton__J075P:hover {
  background-color: transparent;
  color: #7fc5bf;
  border: 1px solid #7fc5bf;
}

.MachineModal_modalOverlay__EUk7r {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.MachineModal_modalContent__Sc6Tp {
  position: relative;
  background-color: white;
  padding: 16px;
  border-radius: 4px;
  max-width: 90%;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
}

.MachineModal_closeButton__ot1Ow {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 24px;
  line-height: 1;
  background-color: transparent;
  border: none;
  color: #333;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/MachineModal/MachineModal.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd;sEACoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* MachineModal.module.css */\n.openModalButton {\n  background-color: #7fc5bf;\n  color: black;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n  width: 9rem;\n  line-height: 2.4;\n}\n\n.openModalButton:hover {\n  background-color: transparent;\n  color: #7fc5bf;\n  border: 1px solid #7fc5bf;\n}\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  position: relative;\n  background-color: white;\n  padding: 16px;\n  border-radius: 4px;\n  max-width: 90%;\n  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),\n    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);\n}\n\n.closeButton {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  font-size: 24px;\n  line-height: 1;\n  background-color: transparent;\n  border: none;\n  color: #333;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"openModalButton": `MachineModal_openModalButton__J075P`,
	"modalOverlay": `MachineModal_modalOverlay__EUk7r`,
	"modalContent": `MachineModal_modalContent__Sc6Tp`,
	"closeButton": `MachineModal_closeButton__ot1Ow`
};
export default ___CSS_LOADER_EXPORT___;
